export default class GenericModel {
  id?: number;
}
